import { render } from "./BasePersistentSplitButton.vue?vue&type=template&id=94fc0fe8&scoped=true"
import script from "./BasePersistentSplitButton.vue?vue&type=script&lang=js"
export * from "./BasePersistentSplitButton.vue?vue&type=script&lang=js"

import "./BasePersistentSplitButton.vue?vue&type=style&index=0&id=94fc0fe8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94fc0fe8"]])

export default __exports__